<template>
    <div>
        <template v-if="company === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Active Companies ({{active_count}})</h1>
                <router-link v-if="onboard_company" to="/addNewCompany" class="btn btn-primary float-right active"> Add New Company</router-link>
                <div class="searching float-right mr-2">
                    <input id="search_active" type="text" placeholder="Search" class="form-control search" name="" />
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
				<div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
					<table id="companyTable" class="table">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Risk Rating</th>
                                <th>Risk Status</th>
                                <th>Payment Engine</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th>Onboard Date</th>
                                <th>Status</th>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                    </table>
				</div>
			</div>
        </template>
        <template v-else-if="company === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="company === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                company: null,
                dtActive : null,
                active_count : 0,
                onboard_company : null,
                edit_onboarded_company : null,
                view_onboarded_company : null,
                delete_onboarded_company : null
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('company|onboard_company|edit_onboarded_company|view_onboarded_company|delete_onboarded_company').then(result => {
                this.onboard_company = result.onboard_company;
                this.edit_onboarded_company = result.edit_onboarded_company;
                this.view_onboarded_company = result.view_onboarded_company;
                this.delete_onboarded_company = result.delete_onboarded_company;
                this.company = result.company;
            }).then(result => {
                if(this.company == true){
                    this.activeCompanies();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            activeCompanies(){
                var self = this;
                this.dtActive = $('#companyTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listCompanies",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": 'records',
                        "data": function ( d ) {
                            d.tab = 'active';
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name', render: function(data,type,full){
                            if(full['vrCorporate'] == 'YES') {
                                var $type_badge = '<span class="badge badge-primary" data-toggle="tooltip" data-placement="top" title="Company Account Type: Virtual"> V </span> ';
                            } else {
                                var $type_badge = '<span class="badge badge-success" data-toggle="tooltip" data-placement="top" title="Company Account Type: Corporate"> C </span> ';
                            }
                            return $type_badge+data;
                        }},
                        {data: 'risk_rating'},
                        {data: 'risk_status'},
                        {data: 'payment_engine'},
                        {data: 'phone'},
                        {data: 'email'},
                        {data: 'address_1'},
                        {data: "on_board_date", 
                        "render": function (data) {
                            var date = new Date(data);
                            var month = date.getMonth() + 1;
                            return date.getDate() + "/" +(month.length > 1 ? month : "0" + month) + "/" +  date.getFullYear(); 
                        }},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $view_url = '/companyDetailedView/'+full['id'];
                            var $edit_url = '/editOnboardedCompany/'+full['id'];
                            var actions = '';
                            var company_view_button = '';
                            var company_edit_button = '';
                            var company_delete_button = '';
                            if(self.view_onboarded_company === true) {
                                company_view_button = '<a v-if"0" href="javascript:void(0);" onclick="window.vueRouterPush(\''+$view_url+'\')" class="action edit"><i class="fas fa-eye"></i></a>';
                            }
                            if(self.edit_onboarded_company === true) {
                                company_edit_button = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$edit_url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                            }
                            if(self.delete_onboarded_company === true) {
                                company_delete_button = '<a href="javascript:void(0);" onclick="VueComponents.allCompaniesComponent.methods.deleteCompany('+full['id']+')" class="action edit"><i class="fas fa-trash"></i></a>';
                            }
                            return company_view_button + ' ' + company_edit_button + ' ' + company_delete_button;
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 5 ]
                    }],
                    "initComplete": (settings, json) => { this.active_count = json.recordsTotal; this.$Progress.finish();}
                });
                $('#search_active').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        gThat.dtActive.search(this.value).draw();
                    }
                });
            },
           deleteCompany(id){
               var that = this;
               gThat.$Progress.start();
               swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this company !",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get("/api/softDeleteCompany/"+id)
                        .then(res => {
                            if(res.status == 200){
                                if(res.data.status == 200){
                                    gThat.$Progress.finish();
                                    gThat.dtActive.ajax.reload( json => {
                                        gThat.active_count = json.recordsTotal;
                                    }, false);
                                    gThat.showAlertBox('success','Company deleted successfully.');
                                }else{
                                    gThat.showToastBox('error','System is not responding! Please try again later.');
                                }
                            }else{
                                gThat.$Progress.fail();
                                gThat.showAlertBox('error','System is not responding! Please try again later.');
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            gThat.$Progress.fail();
                            gThat.showAlertBox('error','System is not responding! Please try again later.');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        gThat.$Progress.finish();
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                });
                
           },
        },
    }
</script>
